const urlArvoreRag = "/arvoresrag";
const urlParametroExercicio = "/parametroexerciciosrag";

export function carregarArvoreRag() {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`${urlArvoreRag}/carregar`).then((res) => {
      resolve(res.data);
    });
  });
}

export function listarVisaoParamExercRag() {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`${urlParametroExercicio}/visao`).then((res) => {
      resolve(res.data);
    });
  });
}

export function listarOrgaosParaContaAcesso(idenExercicio) {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`/arvoresrag/orgaos/${idenExercicio}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function listarOrgaosPermissao(idenExercicio) {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`/arvoresrag/orgaos/permissao/${idenExercicio}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function carregarArvoreRagPermissao() {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`${urlArvoreRag}/carregar/permissao`).then((res) => {
      resolve(res.data);
    });
  });
}

export function carregarArvoreRagComFiltro(filtro, pRetorno, carregaArvoreGeral) {
  let urlServico = "";
  let defaultArvore = { content: { key: null, descricaoItem: null, tipoItemPta: null, idenItemPai: null } };
  let retorno = {
    arvorePtaMonitoras: pRetorno.arvorePtaMonitoras != null ? pRetorno.arvorePtaMonitoras : defaultArvore,
    listaExercicios: pRetorno.listaExercicios != null ? pRetorno.listaExercicios : null,
    parametroExercicio: pRetorno.parametroExercicio != null ? pRetorno.parametroExercicio : null,
    orgaoFiplans: pRetorno.orgaoFiplans != null ? pRetorno.orgaoFiplans : null,
    unidadeOrcamentarias: pRetorno.unidadeOrcamentarias != null ? pRetorno.unidadeOrcamentarias : null,
    programas: pRetorno.programas != null ? pRetorno.programas : null,
    eixo: pRetorno.eixo != null ? pRetorno.eixo : null,
    listaAcoes: pRetorno.acao != null ? pRetorno.acao : null,
  };
  if (filtro.idenUo != null) {
    return new Promise((resolve, reject) => {
      urlServico = carregaArvoreGeral
        ? `/v1${urlArvoreRag}/visoes/${filtro.idenOrgao}/${filtro.idenUo}`
        : `${urlArvoreRag}/visoes/permissao/${filtro.idenOrgao}/${filtro.idenUo}`;
      window.$http.get(urlServico).then((res) => {
        retorno.arvorePtaMonitoras = res.data;
        resolve(retorno);
      });
    });
  } else if (filtro.idenOrgao != null) {
    return new Promise((resolve, reject) => {
      urlServico = carregaArvoreGeral
        ? `${urlArvoreRag}/uos/${filtro.idenOrgao}`
        : `${urlArvoreRag}/uos/permissao/${filtro.idenOrgao}`;

      window.$http.get(urlServico).then((res) => {
        retorno.unidadeOrcamentarias = res.data;
        resolve(retorno);
      });
    });
  } else if (filtro.idenExercicio != null) {
    return new Promise((resolve, reject) => {
      urlServico = carregaArvoreGeral
        ? `${urlArvoreRag}/orgaos/${filtro.idenExercicio}`
        : `${urlArvoreRag}/orgaos/permissao/${filtro.idenExercicio}`;
      window.$http.get(urlServico).then((res) => {
        retorno.orgaoFiplans = res.data;
        retorno.arvorePtaMonitoras = defaultArvore;
        retorno.unidadeOrcamentarias = null;
        window.$http.get(`${urlParametroExercicio}/buscarPorExercicio/${filtro.idenExercicio}`).then((res) => {
          retorno.parametroExercicio = res.data;
          resolve(retorno);
        });
      });
    });
  }
}

export function buscarUo(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`${urlArvoreRag}/uo/programa`, JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function buscarExercicio() {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`${urlArvoreRag}/carregar`).then((res) => {
      resolve(res);
    });
  });
}

export function buscaEixo(idenExercicio) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/eixos/exercicio/" + idenExercicio).then((res) => {
      resolve(res);
    });
  });
}
export function buscaProduto(idenPtaMonitora) {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`${urlArvoreRag}/produto/permissao/` + idenPtaMonitora).then((res) => {
      resolve(res);
    });
  });
}

export function buscarUoPorIdenExercicio(idenExercicio) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/unidadeorcamentarias/exercicio/" + idenExercicio).then((res) => {
      resolve(res);
    });
  });
}

export function buscarSubAcao(idenPtaMonitora) {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`${urlArvoreRag}/subacao/permissao/` + idenPtaMonitora).then((res) => {
      resolve(res);
    });
  });
}

export function buscarUoPorExercicioPermissoes(idenExercicio) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/arvoresrag/uos/permissao/buscarPorExercicio/" + idenExercicio).then((res) => {
      resolve(res);
    });
  });
}
export function buscaCiclo(idenExercicio) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/ciclos/exercicio/" + idenExercicio).then((res) => {
      resolve(res);
    });
  });
}

export function buscaUnidadeExecucao(idenUnidadeExecucao) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/unidadesexecucao/buscarSubUnidadesExecucao/" + idenUnidadeExecucao).then((res) => {
      resolve(res);
    });
  });
}

export function buscarOrgaos(idenExercicio) {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`${urlArvoreRag}/orgaos/` + idenExercicio).then((res) => {
      resolve(res);
    });
  });
}
export function buscaSubUnidadeExecucao(idenUnidadeExecucao) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/unidadesexecucao/buscarSubUnidadesExecucao/" + idenUnidadeExecucao).then((res) => {
      resolve(res);
    });
  });
}

export function buscarPrograma(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/programas/exercicioeixotipo/", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}
export function buscarProgramaPermissao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/arvoresrag/programaFiltro/permissao/", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}
export function buscaStatusExecucao() {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/status/listarRelatorio/").then((res) => {
      resolve(res);
    });
  });
}
export function buscaUoExercicio(idenExercicio, carregaPermissao) {
  let urlServico = carregaPermissao
    ? "/arvoresrag/uos/permissao/buscarPorExercicio/" + idenExercicio
    : "/unidadeorcamentarias/exercicio/" + idenExercicio;
  return new Promise(async (resolve, reject) => {
    window.$http.get(urlServico).then((res) => {
      resolve(res);
    });
  });
}
export function buscaProgramaExercicio(idenExercicio, carregaPermissao) {
  let urlServico = carregaPermissao
    ? "/arvoresrag/programa/permissao/exercicio/" + idenExercicio
    : "/programas/exercicio/" + idenExercicio;
  return new Promise(async (resolve, reject) => {
    window.$http.get(urlServico).then((res) => {
      resolve(res);
    });
  });
}
export function gerarRelatorioRestricao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelrestitensmonitoraveis", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function buscarAcoes(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/ptafiplans/uo/programa", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function buscarAcoesPermissao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/arvoresrag/acao/permissao", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioPermissoes(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelpermissoes", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioFinanceiroSintetico(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelfinanceirosinteticoacao", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioFinanceiroAnalitco(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelfinanceiroanalitico", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}
export function gerarRelatorioBaseGeral(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelbasegeral", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioExecucaoFisicaAnalitica(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelexecfisicaanalitica", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioExecucaoFisicaSintetico(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelexecfisicasintetico", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioStatusExecucao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelstatusexecucao", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRTFRagRelAnal(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/ragrelanalrag", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarPDFRagApuracaoInd(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/ragrelapuracaoind", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarPDFRagExecFisica(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/ragrelexecfisica", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarPDFRagExecOrcam(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/ragrelexecorcame", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarPDFRagPendencias(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/ragrelpendencias", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function buscaProgramaPermissao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/arvoresrag/programaFiltro/permissao", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioPermissao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/ragrelpermissoes", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarPDFAnaliseDevol(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/raganalisedevol", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarPDFODSPublicoTransversal(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/ragodspublicotransv", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarPDFExecucaoOrcamentariaAcao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/ragexecorcamentariaacao", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioRagBaseGeralPrograma(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/rag/base-geral-programa", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioRagBaseGeralAcao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/rag/base-geral-acao", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioRagApuracaoIndicadorProgramaAcao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/rag/apuracao-indicador-programa-acao", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioRagProrrogacao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/rag/prorrogacoes", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}


export function gerarRelatorioRagSugestaoMelhoria(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/rag/sugestao-melhoria", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}
